import React from "react";
import { InfoBanner, Spinner, TableHeader } from "@services/ui-components";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useReactiveVar } from "@apollo/client";
import { useParams } from "react-router-dom";
import UpdateRecoveryProductForm from "./UpdateRecoveryProductForm";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

const RecoveryProduct: React.FC = () => {
    const { t } = useTranslation();
    const { id, branchId } = useParams();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);

    if (!currentCompanyId) return <Spinner />;

    return (
        <div className="mb-3">
            <InfoBanner>
                <p className="fs-7 mb-0">{t("Required fields are marked with an asterisk - *.")}</p>
            </InfoBanner>
            <TableHeader
                title={t("Restore the Product")}
                paths={[
                    {
                        path: `/warehouse/product/${currentCompanyId}/${id}/restore/branch/${branchId}`,
                        label: t("Warehouse accounting"),
                    },
                    { path: `/warehouse/product/${currentCompanyId}/branch/${branchId}`, label: t("Products") },
                    {
                        path: `/warehouse/product/${currentCompanyId}/${id}/restore/branch/${branchId}`,
                        label: t("Restore the" + " Product"),
                    },
                ]}
                colSize={12}
            />
            <Row>
                <UpdateRecoveryProductForm />
            </Row>
        </div>
    );
};

export default RecoveryProduct;
